"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusGroup = exports.customOnBlur = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var prop_types_1 = __importDefault(require("prop-types"));
var react_jss_1 = require("react-jss");
// TODO: Decide if we need to bother with lifting dom-helpers, or just accept the mostly copy and paste.
var findParentOfElementOrSelfWhere = function (el, matchFn) {
    var parent = el;
    while (parent) {
        if (matchFn(parent)) {
            return parent;
        }
        parent = parent.parentElement;
    }
    return null;
};
var findSearchFieldParent = function (element) {
    return findParentOfElementOrSelfWhere(element, function (el) { return el.getAttribute("data-search-field"); });
};
var isSameOrChildOfSearchFieldElement = function (element) {
    return findSearchFieldParent(element) !== null;
};
// TODO: Allow for a generic focus target instead of a hard coded 'input' selector.
var findInputElement = function (peerElement) {
    var searchField = findSearchFieldParent(peerElement);
    return searchField.querySelector("input");
};
var useFocusGroupStyles = (0, react_jss_1.createUseStyles)({
    focusContainer: {
        position: "relative",
        outline: "none",
    },
});
var customOnBlur = function (e, onBlur) {
    if (e.relatedTarget && isSameOrChildOfSearchFieldElement(e.relatedTarget)) {
        return;
    }
    onBlur(e);
};
exports.customOnBlur = customOnBlur;
// TODO: Instances of FocusGroup should have a unique ID to find, instead of 'data-search-field'
var FocusGroup = function (_a) {
    var children = _a.children, onBlur = _a.onBlur, onFocus = _a.onFocus;
    var classes = useFocusGroupStyles();
    return ((0, jsx_runtime_1.jsx)("div", { className: classes.focusContainer, "data-search-field": true, "data-ta-locator": "focus_group", onClick: function (e) {
            if (isSameOrChildOfSearchFieldElement(e.target)) {
                findInputElement(e.target).focus();
            }
        }, onBlur: 
        /* istanbul ignore next */
        function (e) {
            (0, exports.customOnBlur)(e, onBlur);
        }, onFocus: onFocus, children: children }));
};
exports.FocusGroup = FocusGroup;
// TODO: Make a FocusGroupProps interface
exports.FocusGroup.propTypes = {
    onFocus: prop_types_1.default.func,
    onBlur: prop_types_1.default.func,
};
//# sourceMappingURL=FocusGroup.js.map